import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import Button from '../../elements-buttons/Button';
import TextButton from '../../elements-buttons/text-button';
import { FormattedMessage } from 'react-intl';
import { intlVatRegisteredModalHeader } from '../data/translationsData';
import { hostVatSupportLink, guestVatSupportLink } from '../data/supportLinks';

const TaxRegisteredModal = (props) => (
  <BootstrapModal
    {...props}
    modalSize="sm-size"
    modalClass="tax-registered-modal"
    onClose={() => props.closeModal('taxRegisteredModal')}
    header={<h3><FormattedMessage { ...intlVatRegisteredModalHeader[props.intlDataKey] }/></h3>}
    body={
      <div className="text-gray-600 text-center">
        <div>
          <FormattedMessage id="hosting.vat_registered_modal.add_tax_copy" defaultMessage="Adding your tax registration details may change how taxes are charged on your bookings." />
          <a className="margin-sm-left" href={props.isHost ? hostVatSupportLink : guestVatSupportLink}
            target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="hosting.vat_registered_modal.learn_more_link" defaultMessage="Learn more" />
          </a>
        </div>
      </div>
    }
    footer={
      <div className="flex middle column">
        <div>
          <Button
            category="primary"
            isLoading={props.showBtnSpinner}
            onClick={props.routeToTaxesTab}
          >
            <FormattedMessage id="hosting.vat_registered_modal.add_tax_details_button" defaultMessage="Add tax details" />
          </Button>
        </div>
        <div>
          <TextButton
            buttonText={<FormattedMessage
              id="hosting.vat_registered_modal.skip_text"
              defaultMessage="Skip" />}
            onClick={() => props.closeModal('taxRegisteredModal')}
            classNames='margin-lg-top'
          />
        </div>
      </div>
    }
  />
);

TaxRegisteredModal.propTypes = {
  isHost: PropTypes.bool
};

export default TaxRegisteredModal;
